/**
 * 商户门户权限闸门（US-002 / AUTH-004）。
 * 权限来源：loadSession()?.me?.permissions；空 / 失败视为无权限。
 * 读/写别名与后端 hasAnyAuthority 一致，禁止自造码。
 */

/** 快捷处置可读：预拉、菜单叶、GET 列表 */
export const QUICK_ACTION_READ_CODES = ['risk.action:read', 'merchant.risk:write'] as const;

/** 快捷处置可写：冻结 / 调额 / 争议 */
const QUICK_ACTION_WRITE_CODES = ['risk.action:write', 'merchant.risk:write'] as const;

/** 与 MerchantSession.me 对齐的最小会话形状（避免本文件依赖登录协议） */
type MerchantPermissionSession = {
  me?: { permissions?: readonly string[] | null } | null;
} | null | undefined;

/** 从 session.me.permissions 取值；me 失败或空数组 → [] */
export function merchantPermissionsOf(
  session: MerchantPermissionSession,
): readonly string[] {
  const permissions = session?.me?.permissions;
  if (!Array.isArray(permissions) || permissions.length === 0) {
    return [];
  }
  return permissions;
}

/** 权限列表是否命中任一码 */
export function hasMerchantPermission(
  permissions: readonly string[] | null | undefined,
  codes: readonly string[],
): boolean {
  if (!Array.isArray(permissions) || permissions.length === 0 || codes.length === 0) {
    return false;
  }
  return codes.some((code) => permissions.includes(code));
}

export function canReadQuickActions(
  permissions: readonly string[] | null | undefined,
): boolean {
  return hasMerchantPermission(permissions, QUICK_ACTION_READ_CODES);
}

export function canWriteQuickActions(
  permissions: readonly string[] | null | undefined,
): boolean {
  return hasMerchantPermission(permissions, QUICK_ACTION_WRITE_CODES);
}
